// End-user login/profile has been removed (static site). These selectors are
// kept as neutral stubs so their many consumers compile and take the
// logged-out / empty path without needing edits. Stable references avoid
// spurious re-renders from useSelector.

const EMPTY_ARRAY: any[] = [];
const LOGGED_OUT_AUTH = { loggedIn: 'notLoggedIn' };

export const loggedInSelector = () => 'notLoggedIn';
export const loggedInErrorSelector = () => undefined;
export const authSelector = () => LOGGED_OUT_AUTH;
export const followedTopicsSelector = () => EMPTY_ARRAY;
export const bookmarkedSelector = () => EMPTY_ARRAY;
export const followedPlaylistsSelector = () => EMPTY_ARRAY;
